/* Gift Wrap Functions — extracted from global.js */

function removeFreeGiftwithCart()
  {
    var allItemsCartPage = document.querySelectorAll('#main-cart-items .cart-items .cart-item');
    var allItemsCartDrawer = document.querySelectorAll('cart-drawer.drawer .cart-items .cart-item');

    var giftItem = document.querySelector('.cart-items .cart-item.cart_gift_product')
    if((allItemsCartPage.length == 1 || allItemsCartDrawer.length == 1) && giftItem)
    {
      giftItem.querySelector('cart-remove-button .button').click();
    }
  }

function submitAfterCheckingGiftNote() {
  var textValue = document.querySelector('#gift-note').value;
  if(textValue != "" && document.querySelector('.cart-item.Gift')) {
    var itemId = parseInt(document.querySelector('.cart-item.Gift').dataset.id);

    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: itemId,
        quantity: 1,
        properties: {
          "Gift Message": textValue
        }
      })
    })
    .then(response => response.json())
    .then((cart) => {
      document.querySelector('#realButtonCart').click();
    })
    .catch(error => {
      console.error('Error:', error);
    });
  } else {
    document.querySelector('#realButtonCart').click();
  }
}

const maxNumOfChars = 250;
function countCharacters() {
  if(document.getElementById("current-count")) {
    let numOfEnteredChars = document.getElementById("gift-note").value.length;
    let counter = numOfEnteredChars;
    document.getElementById("current-count").textContent = counter + " / 250";
  }
}

var giftWrapProcessing = false;

function showGiftSpinner() {
  var spinner = document.querySelector('.gift-wrap-spinner');
  if (spinner) spinner.style.display = '';
}
function hideGiftSpinner() {
  var spinner = document.querySelector('.gift-wrap-spinner');
  if (spinner) spinner.style.display = 'none';
}

function addGiftVariant(radioEl) {
  if (giftWrapProcessing) return;

  var newVariantId = parseInt(radioEl.value);
  if (!newVariantId) return;

  var existingGift = document.querySelector('.cart-item.Gift');

  if (existingGift) {
    // If this variant is already the one in cart, do nothing
    if (existingGift.classList.contains('Gift' + newVariantId)) return;

    giftWrapProcessing = true;
    showGiftSpinner();

    // First fetch the cart to find the exact line item to remove
    fetch('/cart.js')
    .then(function(response) { return response.json(); })
    .then(function(cart) {
      // Find the gift item's line number (1-based)
      var giftLineIndex = null;
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].variant_id !== newVariantId &&
            existingGift.classList.contains('Gift' + cart.items[i].variant_id)) {
          giftLineIndex = i + 1;
          break;
        }
      }
      if (!giftLineIndex) {
        giftWrapProcessing = false;
        return;
      }
      // Remove by line number — reliable regardless of properties
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: giftLineIndex, quantity: 0 })
      });
    })
    .then(function(response) { if (response) return response.json(); })
    .then(function(data) {
      if (!data) return;
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: newVariantId, quantity: 1 }] })
      });
    })
    .then(function(response) { if (response) return response.json(); })
    .then(function() {
      refreshCartDrawer();
    })
    .catch(function(error) {
      console.error('Error switching gift variant:', error);
    })
    .finally(function() {
      giftWrapProcessing = false;
      hideGiftSpinner();
    });
  } else {
    // No gift in cart yet — add directly
    giftWrapProcessing = true;
    showGiftSpinner();
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: newVariantId, quantity: 1 }] })
    })
    .then(function(response) { return response.json(); })
    .then(function() {
      refreshCartDrawer();
    })
    .catch(function(error) {
      console.error('Error adding gift variant:', error);
    })
    .finally(function() {
      giftWrapProcessing = false;
      hideGiftSpinner();
    });
  }
}

// Keep old function name as alias in case anything else calls it
function addVariant(selectorNew, currentSelector) {
  var match = selectorNew.match(/wrapper-(\d+)/);
  if (!match) return;
  var fakeRadio = { value: match[1] };
  addGiftVariant(fakeRadio);
}

function checkGiftInCart() {
  var isChecked = document.querySelector('#checkDecision').checked;

  if (!isChecked) {
    // Unchecked — remove gift wrap from cart by line number
    var giftItem = document.querySelector('.cart-item.Gift');
    if (giftItem) {
      fetch('/cart.js')
      .then(function(response) { return response.json(); })
      .then(function(cart) {
        // Find the gift wrap item's variant ID from the DOM class
        var giftVariantId = null;
        giftItem.classList.forEach(function(cls) {
          if (cls !== 'Gift' && cls.indexOf('Gift') === 0) {
            giftVariantId = parseInt(cls.replace('Gift', ''));
          }
        });
        // Find the line number
        for (var i = 0; i < cart.items.length; i++) {
          if (cart.items[i].variant_id === giftVariantId) {
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ line: i + 1, quantity: 0 })
            });
          }
        }
      })
      .then(function(response) { if (response) return response.json(); })
      .then(function() { refreshCartDrawer(); })
      .catch(function(error) { console.error('Error removing gift:', error); });
    }
  } else {
    // Checked — just show the options, don't auto-add anything.
    // User must explicitly click a variant radio to add gift wrap to cart.
  }
}
